module.exports = __webpack_public_path__ + "media/assets/faria_products/BRIDGEU-d899f8c07e578d83e86b5133d4c7f7a359b909a95efbc618592a9851778172c7.png";